const PREFIX = 'airex_cp_lk_';
const AUTO_REFRESH_MIN_SECONDS = 60;
const AUTO_REFRESH_MAX_SECONDS = 300;
const AUTO_REFRESH_DEFAULT_SECONDS = 60;

export function getTheme(): 'light' | 'dark' {
  const saved = localStorage.getItem(PREFIX + 'theme') as 'light' | 'dark' | null;
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function setTheme(theme: 'light' | 'dark') {
  localStorage.setItem(PREFIX + 'theme', theme);
  if (typeof document !== 'undefined') {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('themeChanged', { detail: { theme } }));
  }
}

export function isAutoRefreshEnabled(): boolean {
  const v = localStorage.getItem(PREFIX + 'auto_refresh');
  if (v === null) return true;
  return v === 'true';
}

export function getAutoRefreshInterval(): number {
  const key = PREFIX + 'auto_refresh_interval';
  const raw = localStorage.getItem(key);
  const v = parseInt(raw || String(AUTO_REFRESH_DEFAULT_SECONDS), 10);
  return Math.max(AUTO_REFRESH_MIN_SECONDS, Math.min(AUTO_REFRESH_MAX_SECONDS, v)) || AUTO_REFRESH_DEFAULT_SECONDS;
}

export function setAutoRefreshPreferences(enabled: boolean, interval: number) {
  const sanitized = Math.max(AUTO_REFRESH_MIN_SECONDS, Math.min(AUTO_REFRESH_MAX_SECONDS, Math.round(interval)));
  localStorage.setItem(PREFIX + 'auto_refresh', String(enabled));
  localStorage.setItem(PREFIX + 'auto_refresh_interval', String(sanitized));
  window.dispatchEvent(new CustomEvent('autoRefreshChanged', { detail: { enabled, interval: sanitized } }));
}

export function isDoubleConfirmEnabled(): boolean {
  return localStorage.getItem(PREFIX + 'double_confirm') === 'true';
}

export function setDoubleConfirmEnabled(enabled: boolean) {
  localStorage.setItem(PREFIX + 'double_confirm', String(enabled));
}

/** Маркер «выдал заявку» — персональный флаг для контра */
const ISSUED_REQUESTS_KEY = PREFIX + 'issued_request_ids';

export function getIssuedRequestIds(): Set<number> {
  try {
    const raw = localStorage.getItem(ISSUED_REQUESTS_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return new Set();
    return new Set((arr as number[]).filter((x): x is number => typeof x === 'number'));
  } catch {
    return new Set();
  }
}

export function toggleIssuedRequest(requestId: number): void {
  const set = getIssuedRequestIds();
  if (set.has(requestId)) {
    set.delete(requestId);
  } else {
    set.add(requestId);
  }
  localStorage.setItem(ISSUED_REQUESTS_KEY, JSON.stringify([...set]));
  window.dispatchEvent(new CustomEvent('issuedRequestChanged', { detail: { requestId } }));
}
